import { WSTableCell } from "@wingspanhq/fe-component-library";
import React from "react";

import { useQueryPayrollRunBreakdown } from "../../hooks/useQueryPayrollRunBreakdown";
import { selectorPayrollRunBreakdownCount } from "../../selectors/selectorPayrollRunBreakdownCount";

type Props = {
  payrollRunId: string;
};

/**
 * The run's item count — pay statements or payables, depending on the payroll
 * type. It lives on `PayrollRun.breakdown`, which the list endpoint cannot
 * expand, so the cell fetches its own run rather than the page pre-aggregating
 * one request per row into a map.
 *
 * Shared by both payroll tables: the count is the same read either way, only
 * the column it sits under is named differently.
 */
export const BreakdownCountCell: React.FC<Props> = props => {
  const queryBreakdown = useQueryPayrollRunBreakdown(props.payrollRunId);

  return (
    <WSTableCell
      text={
        queryBreakdown.isLoading
          ? "—"
          : `${selectorPayrollRunBreakdownCount(queryBreakdown.data)}`
      }
    />
  );
};
